
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"28","height":"28","viewBox":"0 0 28 28"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.304 9.344l-7.643-6.113a4.394 4.394 0 00-5.31-.013L3.708 9.344a4.57 4.57 0 00-1.529 4l1.47 8.8a4.336 4.336 0 004.166 3.524h12.37a4.4 4.4 0 004.177-3.537l1.471-8.8a4.688 4.688 0 00-1.529-3.987z","fill":"#bac1cc","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M14 21.873a.88.88 0 01-.874-.874v-3.496a.88.88 0 01.874-.874.88.88 0 01.874.874v3.5a.88.88 0 01-.874.87z","fill":"#bac1cc"}})])
          )
        }
      }
    